module.exports = __webpack_public_path__ + "img/eva-gauna.e734c230.jpg";